// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SelectizeController from "./selectize_controller";
application.register("selectize", SelectizeController);

import AllianceTableSearchController from "./alliance_table_search_controller"
application.register("alliance-table-search", AllianceTableSearchController)
